import styled from "styled-components";

export const SpaceComWrapper = styled.div``